import React from 'react';
import { PURCHASE_ROUTE } from '../../../../constants/Routes';
import PurchaseIcon from '../../../common/icons/purchaseIcon';

export const purchaseGroup = [
  {
    route: PURCHASE_ROUTE,
    icon: <PurchaseIcon size="30px" />,
    title: 'Mis compras realizadas',
    id: 'myPurchasesSection',
  },
];
